import { Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FormField } from '@/shared/components'
import type { UseFormRegister, FieldErrors } from 'react-hook-form'

interface DatePeriodeRowProps {
  index: number
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  onRemove: () => void
}

export function DatePeriodeRow({ index, register, errors, onRemove }: DatePeriodeRowProps) {
  const { t } = useTranslation()

  const inputClass =
    'h-10 w-full rounded-lg border border-neutral-300 bg-neutral-50 px-3 text-sm transition-colors hover:border-neutral-400 focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/25'

  const dateErrors = (errors.datesPeriodes as any)?.[index]

  return (
    <div className="rounded-lg border border-neutral-200 bg-neutral-50/50 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-neutral-600">Date {index + 1}</span>
        <button
          type="button"
          onClick={onRemove}
          className="rounded-md p-1 text-neutral-400 transition-colors hover:bg-red-50 hover:text-red-600"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </div>

      <FormField
        label={t('administration.sections.periods.form.dates.label', 'Libellé')}
        error={dateErrors?.libelle?.message as string}
      >
        <input
          {...register(`datesPeriodes.${index}.libelle`)}
          placeholder={t('administration.sections.periods.form.dates.labelPlaceholder', "Ex: Vacances de Noël, Vacances d'Hiver")}
          className={inputClass}
        />
      </FormField>

      <div className="grid grid-cols-2 gap-3">
        <FormField
          label={t('administration.sections.periods.form.dates.startDate', 'Date de début')}
          error={dateErrors?.dateDebut?.message as string}
        >
          <input
            type="date"
            {...register(`datesPeriodes.${index}.dateDebut`)}
            className={inputClass}
          />
        </FormField>
        <FormField
          label={t('administration.sections.periods.form.dates.endDate', 'Date de fin')}
          error={dateErrors?.dateFin?.message as string}
        >
          <input
            type="date"
            {...register(`datesPeriodes.${index}.dateFin`)}
            className={inputClass}
          />
        </FormField>
      </div>
    </div>
  )
}
